import { doPost } from '../http/httpHelper';

export const uploadProductsSpreadsheet = async ({ fileName, products }) => {
    const safeFileName = String(fileName ?? '').trim();
    const safeProducts = Array.isArray(products) ? products : null;

    if (!safeFileName) throw new Error('Nome do arquivo inválido.');
    if (!safeProducts) throw new Error('Planilha inválida: produtos não encontrados.');

    const resp = await doPost('/uploadProducts', {
        file_name: safeFileName,
        products: safeProducts,
    });

    if (!resp) throw new Error('Falha ao enviar a planilha.');

    if (resp.httpStatus && resp.httpStatus !== 200) {
        const message = (typeof resp.body === 'string' && resp.body) || resp.body?.message || 'Falha ao enviar a planilha.';
        throw new Error(message);
    }

    return resp?.body ?? resp;
};
